export const keyFramesClasses = {
  hideToRight: "hide-to-right",
  hideToLeft: "hide-to-left",
  showFromRight: 'show-from-right',
  showFromLeft: 'show-from-left'
}